import React from 'react';
import { Tr, Td } from '../../components/tables';
import { Money, VareDataModalLink } from '../../containers/commerce';
import { LiterFormat } from '../../components/Format';
import { sanitizeMeasurement } from '../../lib/helpers';

export default ({
  name,
  countPrColli,
  price,
  varenr,
  liter,
}) => (
  <Tr>
    <Td>
      <VareDataModalLink varenr={varenr}>
        {name} <LiterFormat liter={liter} divider={sanitizeMeasurement(countPrColli)} cl />
      </VareDataModalLink>
    </Td>
    <Td textRight>
      {countPrColli}
    </Td>
    <Td textRight>
      <Money money={price} multiplier={1 / (sanitizeMeasurement(countPrColli))} noSuffix />
    </Td>
    <Td textRight>
      <Money money={price} noSuffix />
    </Td>
  </Tr>
);
